import { render } from "./ManagerRatesItem.vue?vue&type=template&id=d1068750"
import script from "./ManagerRatesItem.vue?vue&type=script&lang=js"
export * from "./ManagerRatesItem.vue?vue&type=script&lang=js"

import "./ManagerRatesItem.vue?vue&type=style&index=0&id=d1068750&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__